import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
// eslint-disable-next-line jira/import-whitelist
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { fg } from '@atlassian/jira-feature-gating';
import imgSVG from './assets/project-summary-skeleton.tpl.svg';

export const ProjectSummarySkeleton = (): React.JSX.Element => {
	if (fg('jsm_reporting_enable_byok_checks_summary_page')) {
		return (
			<UFOLoadHold name="summary-page-skeleton" hold>
				<AppSkeletonImage src={imgSVG} />
			</UFOLoadHold>
		);
	}

	return <AppSkeletonImage src={imgSVG} />;
};
